import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";

export const PrivateRoute = ({ allowedRoles = [], children }) => {
  const { user } = useAuth();

  if (!user?.token) return <Navigate to="/login" replace />;

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.tipusu)) {
    return <Navigate to="/403" replace />;
  }

  return children || <Outlet />;
};
